import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { useNavigate } from 'react-router-dom';
import { Security } from '@okta/okta-react';
import oktaConfig from './OktaConfig';
import { App } from './App';
import { OktaAuthProvider } from './Context/OktaAuthProvider';

// useNavigate below re-renders this on every navigation, and Security never stops the instance it
// replaces -- a per-render instance therefore leaks token services and re-runs every effect keyed on it.
const oktaAuth = new OktaAuth({ ...oktaConfig });

export const OktaAppContainer = () => {
  const navigate = useNavigate();

  const restoreOriginalUri = async (_oktaAuth: OktaAuth, originalUri: string) => {
    const relativeUrl = toRelativeUrl(originalUri, window.location.origin);
    navigate(relativeUrl);
  };

  return (
    <Security
      oktaAuth={oktaAuth}
      restoreOriginalUri={restoreOriginalUri}>
      <OktaAuthProvider>
        <App />
      </OktaAuthProvider>
    </Security>
  );
};
